<template>
  <tasks scope="DDO"></tasks>
</template>

<script>
import Tasks from "./tasks.vue";
export default {
  components: { Tasks },

  computed: {},
};
</script>
